import React, { useRef, useEffect } from "react";
function MainVideo({
  src,
  srcMp4,
  alt,
  playVideo = true,
  noClipPath,
  expand,
  width,
  height,
  objectFit,
}) {
  return (
    <>
      <div
        data-cy="Superbanner Video"
        className={`superbanner-video ${expand ? 'expand': ''} ${noClipPath ? '' : 'clip-path'} object-fit-${objectFit ? objectFit : 'contain'}`}
        style={{width: width || '80%', height: height || 'auto'}}
        dangerouslySetInnerHTML={{
          __html: `
      <video muted loop playsinline autoplay>
          <source src="${src}" alt="${alt}" type="video/webm"></source>
          <source src="${srcMp4}" alt="${alt}" type="video/mp4"></source>
      </video>
      `,
        }}
      ></div>
      {/* INJECT_STYLED_JSX_TAG */}
    </>
  );
}

export default MainVideo;

